// extracted by css-extract-rspack-plugin
var _1 = "OTYUWXOXR2MYj7iP";
var _2 = "uaSou37jkcsJyFP9";
export { _1 as "containerError", _2 as "errorText" }
